export const CONNECT_BUTTON_STACK_BREAKPOINT = 430;

const toInset = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const getUsableViewportWidth = (webApp, browserWindow = window) => {
    const viewportWidth = Number(browserWindow.visualViewport?.width)
        || Number(browserWindow.innerWidth)
        || Number(browserWindow.document?.documentElement?.clientWidth)
        || 0;
    const safeArea = webApp?.contentSafeAreaInset || webApp?.safeAreaInset || {};

    return Math.max(0, viewportWidth - toInset(safeArea.left) - toInset(safeArea.right));
};

export const getSecondaryButtonPosition = (webApp, browserWindow = window) => (
    getUsableViewportWidth(webApp, browserWindow) <= CONNECT_BUTTON_STACK_BREAKPOINT
        ? 'top'
        : 'left'
);

export const syncTelegramBottomButtons = (webApp, browserWindow = window) => {
    const secondaryButton = webApp?.SecondaryButton;
    if (!secondaryButton) {
        return null;
    }

    const position = getSecondaryButtonPosition(webApp, browserWindow);

    if (typeof secondaryButton.setParams === 'function') {
        secondaryButton.setParams({ position });
    } else {
        secondaryButton.position = position;
    }

    return position;
};
